import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import Swiper from "../Components/Swiper";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function Download() {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.outerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div className={`background ${isMobile ? 'header-placement' : ''}`}>
            {!isMobile && <Swiper />}
            <Navbar activeLink='download' />
            <div className='wrapper mt-5'>


                <div className='row col-8'>
                    <div className='col text-center'>

                        <a href="itms-services://?action=download-manifest&url=https://test-erp-app.arigbank.mn/app/manifest.plist" target="_blank" rel="noreferrer">
                            <img
                                src={require("../assets/icon/AppStoreLogo.png")} alt="" style={{ width: 200, height: 200 }} />
                            <p className='mt-3'>
                                IOS app татах
                            </p>
                        </a>

                    </div>
                    <div className='col text-center'>
                        <a href="https://test-erp-app.arigbank.mn/app/arig.apk" target="_blank" rel="noreferrer">
                            <img
                                src={require("../assets/icon/PlayStoreLogo.png")} alt="" style={{ width: 200, height: 200 }} />
                            <p className='mt-3'>
                                Android app татах
                            </p>
                        </a>

                    </div>
                </div>


                <Footer isMobile={isMobile} />
            </div>
        </div>
    );
}

export default Download;
